import { Component } from '@theme/component';

/**
 * @typedef {Object} TestimonialsExpandRefs
 * @property {HTMLButtonElement} button
 * @property {HTMLElement} content
 */

/**
 * @extends {Component<TestimonialsExpandRefs>}
 */
class TestimonialsExpand extends Component {
  requiredRefs = ['button', 'content'];

  /** @type {Animation | undefined} */
  #animation;
  #animationSpeed = 300;

  expand = (event) => {
    event.preventDefault();
    if (this.dataset.expanded === 'true') return;

    const { content, button } = this.refs;
    const startHeight = content.offsetHeight;

    this.dataset.expanded = 'true';
    button.setAttribute('aria-expanded', 'true');

    const endHeight = content.scrollHeight;

    content.style.overflow = 'hidden';
    this.#animation?.cancel();
    this.#animation = content.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: this.#animationSpeed, easing: 'ease-in-out' }
    );
    this.#animation.onfinish = () => {
      content.style.removeProperty('height');
      content.style.overflow = '';
    };
  };
}

if (!customElements.get('testimonials-expand')) {
  customElements.define('testimonials-expand', TestimonialsExpand);
}
